import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

interface ConnectionErrorScreenProps {
  buttonLabel: string
  onButtonClick: () => void
  /**
   * `overlay` рисует карточку поверх PreJoin, а не вместо всей страницы.
   */
  overlay?: boolean
}

/**
 * Тёмная карточка с инструкцией, когда не удалось подключиться к встрече.
 *
 * На PreJoin это оверлей: форму входа не убираем, но кликать по ней нельзя.
 * В звонке это по-прежнему целая страница.
 */
export function ConnectionErrorScreen({
  buttonLabel,
  onButtonClick,
  overlay = false,
}: ConnectionErrorScreenProps) {
  const { t } = useTranslation()
  const Wrapper = overlay ? 'div' : 'main'

  return (
    <Wrapper
      className={clsx('connection-error-page', overlay && 'organizer-code-error-overlay')}
      data-lk-theme="default"
    >
      <section
        className="connection-error-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="connection-error-title"
      >
        <h1 id="connection-error-title" className="connection-error-title">
          {t('connectionErrorTitle')}
        </h1>

        <p className="connection-error-description">{t('connectionErrorDescription')}</p>

        <ol className="connection-error-steps">
          <li>{t('connectionErrorStepBrowser')}</li>
          <li>{t('connectionErrorStepNetwork')}</li>
          <li>{t('connectionErrorStepVpn')}</li>
          <li>{t('connectionErrorStepIncognito')}</li>
        </ol>

        <button className="connection-error-button" type="button" onClick={onButtonClick}>
          {buttonLabel}
        </button>
      </section>
    </Wrapper>
  )
}
